import { AnalyticTag } from './analytics';
import { pushAnalytics } from './utils';

export const generatePayload = (reference: AnalyticTag) => {
  const app = 'directdebit';
  const options = reference.split('.');
  const actionType = options?.[0] || '';
  const index = options?.[1] || '';
  const details = options?.[3] ? `.${options[3]}` : '';
  const name = `web.${options?.[2]}${details}`;
  return {
    event: `process.web.${app}`,
    process: {
      step: {
        index,
        dateTime: Date.now(),
      },
      name,
      actionType,
    },
  };
};

/** Push GA event. Use for onmousedown to fire an event before navigation. */
export function emitGAMouseClickHandler(event: React.MouseEvent) {
  const element = event.target as HTMLElement;
  const gaEventName = element?.getAttribute('data-ga');
  if (gaEventName) {
    pushAnalytics(gaEventName as AnalyticTag);
  }
}

export function step1Listener(e: Event) {
  const dobField = document.querySelector('#identifyYourAccountForm\\.dob');
  const accountField = document.querySelector(
    '#identifyYourAccountForm\\.accountNumber'
  );
  const firstNameField = document.querySelector(
    '#identifyYourAccountForm\\.firstName'
  );

  const lastNameField = document.querySelector(
    '#identifyYourAccountForm\\.lastName'
  );
  const id = (e.target as HTMLInputElement).id;
  if (id === accountField?.id) {
    pushAnalytics('click.1.directdebitstep1.accountrefno');
  }
  if (id === firstNameField?.id) {
    pushAnalytics('click.2.directdebitstep1.firstname');
  }
  if (id === lastNameField?.id) {
    pushAnalytics('click.3.directdebitstep1.lastname');
  }
  if (id === dobField?.id) {
    pushAnalytics('click.4.directdebitstep1.DOB');
  }
}

export function step3Listener(e: Event) {
  const accountInfoCheckbox = document.querySelector(
    '#debitDetails\\.accountConfirmation'
  );
  const privacyCheckbox = document.querySelector(
    '#debitDetails\\.collectDataConfirmation'
  );

  const invoiceConfirmationCheckBox = document.querySelector(
    '#debitDetails\\.invoiceConfirmation'
  );
  if (e.target === accountInfoCheckbox) {
    pushAnalytics('click.1.directdebitstep3.accountholdercheckbox');
  }
  if (e.target === privacyCheckbox) {
    pushAnalytics('click.2.directdebitstep3.privacycheckbox');
  }
  if (e.target === invoiceConfirmationCheckBox) {
    pushAnalytics('click.3.directdebitstep3.osbalancecheckbox');
  }
}
export function step4Listener(e: Event) {
  const consentCheckBox = document.getElementById('review.consent');
  if (e.target === consentCheckBox) {
    pushAnalytics('click.1.directdebitstep4.DDagreementcheckbox');
  }
}

export function paymentSetpListener(e: Event) {
  const bankNameInput = document.getElementById('debitDetails.bankAccountName');
  const bankBSBInput = document.getElementById('debitDetails.bsbNumber');
  const bankAccountInput = document.getElementById(
    'debitDetails.bankAccountNumber'
  );
  const CcNumberInput = document.getElementById('bambora-card-number');
  const CcNameInput = document.getElementById('debitDetails.cardName');
  const CcExpInput = document.getElementById('bambora-expiry');
  const CcCvv = document.getElementById('bambora-cvv');
  const id = (e.target as HTMLInputElement).id;
  if (id === bankNameInput?.id) {
    pushAnalytics('click.1.directdebitstep3.accountname');
  }
  if (id === bankBSBInput?.id) {
    pushAnalytics('click.2.directdebitstep3.BSB');
  }
  if (id === bankAccountInput?.id) {
    pushAnalytics('click.3.directdebitstep3.accountnumber');
  }
  if (id === CcNumberInput?.id) {
    pushAnalytics('click.1.directdebitstep3.cardnumber');
  }
  if (id === CcNameInput?.id) {
    pushAnalytics('click.2.directdebitstep3.nameoncard');
  }
  if (id === CcExpInput?.id) {
    pushAnalytics('click.3.directdebitstep3.expiry');
  }
  if (id === CcCvv?.id) {
    pushAnalytics('click.4.directdebitstep3.cvv');
  }
}

export const analyticsLoaderStep3 = () => {
  document.removeEventListener('click', step3Listener);
  document.addEventListener('click', step3Listener);
};

export const analyticsLoaderStep1 = () => {
  document.removeEventListener('focusout', step1Listener);
  document.addEventListener('focusout', step1Listener);
};

export const analyticsLoaderSetup = () => {
  document.removeEventListener('focusout', paymentSetpListener);
  document.addEventListener('focusout', paymentSetpListener);
};

export const analyticsLoaderStep4 = () => {
  document.removeEventListener('click', step4Listener);
  document.addEventListener('click', step4Listener);
};
